import { gql } from '@apollo/client'

export const GET_PICOS_PRIORITY_LIFETIME_EXECUTION = gql`
  query GetPicOSPriorityLifetimeExecution(
    $input: PicOSPriorityLifetimeExecutionInput!
  ) {
    picosPriorityLifetimeExecution(input: $input) {
      date
      numCompliant
      numPriorities
    }
  }
`
